/**
 * Blueprint for the EventKpis data
 */
export class EventKpis {
  public '@id': string;
  public priceCategories: Array<EventKpisCategory> = [];
  public primaryRequests: EventKpisRequests;
  public secondaryRequests: EventKpisRequests;

  get totalSeatedRequests(): number {
    return this.primaryRequests.seatedRequests + this.secondaryRequests.seatedRequests;
  }

  get totalSeatedTickets(): number {
    return this.primaryRequests.seatedTickets + this.secondaryRequests.seatedTickets;
  }

  constructor(eventKpis: any) {
    this.primaryRequests = new EventKpisRequests(eventKpis.primaryRequests);
    this.secondaryRequests = new EventKpisRequests(eventKpis.secondaryRequests);

    for (const item of eventKpis.priceCategories) {
      this.priceCategories.push(new EventKpisCategory(item));
    }
  }

}

export class EventKpisRequests {
  deferredRequests: number;
  deferredTickets: number;
  prioritizedRequests: number;
  prioritizedTickets: number;
  requests: number;
  seatedRequests: number;
  seatedTickets: number;
  tickets: number;

  constructor(request: any) {
    this.deferredRequests = request.deferredRequests;
    this.deferredTickets = request.deferredTickets;
    this.prioritizedRequests = request.prioritizedRequests;
    this.prioritizedTickets = request.prioritizedTickets;
    this.requests = request.requests;
    this.seatedRequests = request.seatedRequests;
    this.seatedTickets = request.seatedTickets;
    this.tickets = request.tickets;
  }
}

export class EventKpisCategory {
  public name: string;
  public capacity: number;
  public color: string;
  public primaryRequests: EventKpisCategoryRequests;
  public secondaryRequests: EventKpisCategoryRequests;

  public i18nTotal = $localize`:@@lotteryDashboard.general.total:Total`;
  public i18nOpen = $localize`:@@lotteryDashboard.general.open:Open`;

  get displayPrimaryRequests() {
    return `${this.i18nTotal}: ${this.primaryRequests.tickets} | ${this.i18nOpen}: ${this.primaryRequests.ticketsLeft}`;
  }

  get displaySecondaryRequests() {
    return `${this.i18nTotal}: ${this.secondaryRequests.tickets} | ${this.i18nOpen}: ${this.secondaryRequests.ticketsLeft}`;
  }

  constructor(priceCategory: any) {
    this.name = priceCategory.name;
    this.capacity = priceCategory.capacity;
    this.color = priceCategory.color;
    this.primaryRequests = new EventKpisCategoryRequests(priceCategory.primaryRequests);
    this.secondaryRequests = new EventKpisCategoryRequests(priceCategory.secondaryRequests);
  }
}

export class EventKpisCategoryRequests {
  seatedTickets: number;
  tickets: number;
  ticketsLeft: number;

  constructor(request: any) {
    this.seatedTickets = request.seatedTickets;
    this.tickets = request.tickets;
    this.ticketsLeft = this.tickets - this.seatedTickets;
  }
}
